export default "__VITE_ASSET__mt03BfMc__"